import script from "./SovaClubWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./SovaClubWrapper.vue?vue&type=script&setup=true&lang=js"

import "./SovaClubWrapper.vue?vue&type=style&index=0&id=63067812&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63067812"]])

export default __exports__